const isEmpty = (object) => {
  const objectString = JSON.stringify(object);
  return objectString == '{}' || objectString == '';
};

export default isEmpty;
